import { render, staticRenderFns } from "./walletPay.vue?vue&type=template&id=8779b1a2&"
import script from "./walletPay.vue?vue&type=script&lang=js&"
export * from "./walletPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports